import { useState, useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";

import { createRole } from "../../redux/services/RoleService/role.Services";
import { ActiveDepartmentList } from "../../redux/services/DepartmentService/deparment.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { closeModal, refreshList } from "../../redux/features/modalSlice";

function AddRole({data}) {
  const dispatch = useDispatch();
  const { refreshData } = useSelector((state) => state.modal);  
  const [isLoading, setIsLoading] = useState(false);
  const [departmentList, setDepartmentList] = useState([]); 
  const [errors, setErrors] = useState({});
  
  // ✅ Fix 1: Default status "Active" (Capital A) kiya
  const [formData, setFormData] = useState({
    name: "",
    // department_id: "",
    department_id: data?.department_id || "",
    status: "Active", 
  });

  useEffect(() => {
    fetchDepartmentList();
  }, []);

  const fetchDepartmentList = async () => {
    try {
      const res = await ActiveDepartmentList();
      if (res?.success) {
        setDepartmentList(res.data || []);
      }
    } catch (error) {
      console.log(error);
      errorToast("Something went wrong");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.department_id) {
      newErrors.department_id = ["Please select Department"];
    }

    if (!formData.name.trim()) {
      newErrors.name = ["Role Name is required"];
    }

    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }

    try {
      setIsLoading(true);

      const res = await createRole({
        name: formData.name,
        department_id: Number(formData.department_id),
        // ✅ Active hone par 1, Inactive hone par 0 jayega
        status: formData.status === "Active" ? 1 : 0, 
      });

      successToast(res?.message || "Role created successfully");
      
      // ✅ Form reset karte waqt wapas Active set kiya
      setFormData({ name: "", department_id: "", status: "Active" });
       if (refreshData) refreshData();
      dispatch(refreshList());
      dispatch(closeModal());
    } catch (err) {
      console.log(err);
      errorToast(err?.message || "Error creating role ❌");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-form-wrapper">
      <form onSubmit={handleSubmit} className="row">
        <div className="col-md-12 mb-3">
          <label className="form-label">
            Select Department <span className="text-danger">*</span>
          </label>
          <select
            name="department_id"
            value={formData.department_id}
            onChange={handleChange}
            className={`form-control ${errors?.department_id ? "is-invalid" : ""}`}
          >
            <option value="">Select Department</option>
            {departmentList?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          {errors?.department_id && (
            <div className="invalid-feedback d-block">
              {Array.isArray(errors.department_id)
                ? errors.department_id[0]
                : errors.department_id}
            </div>
          )}
        </div>

        <div className="col-md-12 mb-3">
          <label>
            Role Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={`form-control ${errors?.name ? "is-invalid" : ""}`}
            placeholder="Enter role name"
          />
          {errors?.name && (
            <div className="invalid-feedback d-block">{errors.name[0]}</div>
          )}
        </div>

        <div className="col-md-12 mb-3">
          <label>Status</label>
          <select
            name="status"
            // ✅ Fix 2: Yahan direct formData.status pass kiya
            value={formData.status} 
            onChange={handleChange}
            className="form-control"
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <div className="col-md-12 text-end">
          <button type="submit" disabled={isLoading} className="add-btn">
            {isLoading ? "Saving..." : "Save Role"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddRole;